import React, {useState} from 'react';
import NoDataRow from "../../../../../../components/reports/no-data-row.jsx";
import ProjectUtils from "../../../../../../utils/project-utils.js";
import {translate} from "../../../../../../components/translate/translate.jsx";
import {safeFormatDateTime, safeJsonJoin, safeJsonTranslateJoin} from "../utils/safe-operations.jsx";
import {navigateHook} from "../../../../../../hooks/use-navigate.js";

const DetentionListContent = ({ data, boName }) => {
    const navigate = navigateHook();
    const detention_list = data?.detention_list ?? [];

    const [limit, setLimit] = useState(10)
    const passedLimit = detention_list.length > limit;

    const seeMoreOrLess = () => {
        setLimit(prevState => prevState ? null : 10)
    }

    return (
        <>
            <div className="mt-4 mb-6 table-div">
                <span className="table-title mb-2">Lista de detenções {(passedLimit && limit) ? ` (TOP ${limit})` : ''}</span>

                <table id="detention-list-data" className="table report-table mt-2" sheet-name={'Lista de detenções'}>
                    <thead className="thead-background">
                        <tr className="text-left">
                            <th className="w-[7%]">{boName}</th>
                            <th className="w-[12%]">D/H do fato</th>
                            <th className="w-[12%]">CPF</th>
                            <th className="w-[12%]">Nome</th>
                            <th className="w-[12%]">Sexo</th>
                            <th className="w-[12%]">Idade</th>
                            <th className="w-[18%]">Condições</th>
                            <th className="w-[14%]">Encaminhamentos</th>
                        </tr>
                    </thead>

                    <tbody>
                        { !detention_list?.length ? (
                            <NoDataRow colSpan={8} message={"Nenhum registro encontrado."} tdClassName="" alertClassName=""/>
                        ) : (limit ? detention_list.slice(0, limit) : detention_list).map((element, index) => {
                            const url = `/bo/redirect/${element.bo_gcm?.replace('/', '-')}`;

                            return (
                                <>
                                    <tr key={index}>
                                        <td className="w-[7%]"><a onClick={() => navigate(url, true)} className={'inner-link'}>{element.bo_gcm ?? ""}</a></td>
                                        <td className="w-[12%]">{safeFormatDateTime(element.dt_fact)}</td>
                                        <td className="w-[12%]">{ProjectUtils.formatCpfToView(element.cpf) ?? "Não informado"}</td>
                                        <td className="w-[12%]">{element.name ?? "Não informado"}</td>
                                        <td className="w-[12%]">{translate(element.sex)}</td>
                                        <td className="w-[12%]">{element.age_range}</td>
                                        <td className="w-[18%]">{safeJsonJoin(element.conditions) ?? ""}</td>
                                        <td className="w-[14%]">{safeJsonTranslateJoin(element.referrals) ?? ""}</td>
                                    </tr>
                                </>
                            );
                        })}
                    </tbody>
                </table>

                { passedLimit &&
                    <div className="text-end mt-1">
                        <span className="see-more print-hide" onClick={seeMoreOrLess} style={{ cursor: "pointer" }}>
                            {limit ? "Ver mais" : "Ver menos"}
                        </span>
                    </div>
                }

            </div>
        </>
    );
};

export default DetentionListContent;
